
export default {
  name: 'Exception500'
}
